import React from 'react';
import {
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th as ChakraTh,
  Td as ChakraTd,
  Tfoot,
  Container,
  Text,
  Flex,
} from '@chakra-ui/react';
import { RichText } from '../RichText';

const TdIndent = ({ children, ...restProps }) => (
  <ChakraTd fontWeight={300} paddingLeft={50} {...restProps}>
    {children}
  </ChakraTd>
);

const TdBold = ({ children, ...restProps }) => (
  <ChakraTd fontWeight={600} fontSize={{ base: 'sm', xl: 'md' }} {...restProps}>
    {children}
  </ChakraTd>
);

const Td = ({ children, ...restProps }) => (
  <ChakraTd fontWeight={300} fontSize={{ base: 'sm', xl: 'md' }} {...restProps}>
    {children}
  </ChakraTd>
);

const ThFooter = ({ children, ...restProps }) => (
  <ChakraTh
    fontWeight={300}
    fontSize={{ base: 'sm', xl: 'md' }}
    {...restProps}
    padding={10}
    color='black'
  >
    {children}
  </ChakraTh>
);

const Th = ({ children, ...restProps }) => (
  <ChakraTh fontWeight={600} fontSize='xs' padding={10} color='black' {...restProps}>
    {children}
  </ChakraTh>
);

const BudgetTable = ({ data }) => {
  const { title, subtitle, tableNumber, source } = data;

  return (
    <Container maxW='container.xl' padding={{ base: 30, xl: 60 }}>
      <Flex
        flexDirection={{ base: 'column', xl: 'row' }}
        gap={{ base: 0, xl: 30 }}
        p={20}
        background='grey.light'
      >
        <Flex flexDirection='column' mb={20} alignItems='flex-start' spacing='2px' flex='1'>
          {tableNumber && (
            <Text fontSize='xs' textTransform='uppercase' fontWeight={500} letterSpacing={1}>
              {tableNumber}
            </Text>
          )}
          {title && (
            <Text as='h2' textStyle='h4' fontWeight={600}>
              {title}
            </Text>
          )}
          {subtitle && (
            <RichText value={subtitle} fontSize='14px' fontWeight={500} lineHeight={1.1} />
          )}
        </Flex>
        <TableContainer flex='4'>
          <Table variant='simple' size='sm'>
            <Thead>
              <Tr>
                <Th borderBottom='1px solid black' />
                <Th borderBottom='1px solid black'>
                  FY 2022 <br /> Budget
                </Th>
                <Th borderBottom='1px solid black' paddingRight={30}>
                  FY 2022 <br /> Outturn
                </Th>
                <Th borderBottom='1px solid black'>
                  FY 2023 <br /> Budget
                </Th>
                <Th borderBottom='1px solid black' paddingRight={30}>
                  FY 2023 <br /> Outturn
                </Th>
                <Th borderBottom='1px solid black'>
                  FY 2024 <br /> Budget
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <TdBold>Net administrative budget</TdBold>
                <TdBold>1,214</TdBold>
                <TdBold>1,180</TdBold>
                <TdBold>1,295</TdBold>
                <TdBold>1,294</TdBold>
                <TdBold>1,411</TdBold>
              </Tr>
              <Tr>
                <TdIndent>Annual augmentation</TdIndent>
                <Td>-</Td>
                <Td>-</Td>
                <Td>23</Td>
                <Td>-</Td>
                <Td>29</Td>
              </Tr>
              <Tr>
                <TdIndent>Overseas Annual Meetings</TdIndent>
                <Td>-</Td>
                <Td>-</Td>
                <Td>-</Td>
                <Td>-</Td>
                <Td>7</Td>
              </Tr>
              <Tr>
                <TdBold>Receipts</TdBold>
                <TdBold>246</TdBold>
                <TdBold>166</TdBold>
                <TdBold>268</TdBold>
                <TdBold>229</TdBold>
                <TdBold>295</TdBold>
              </Tr>
              <Tr>
                <TdIndent>RST Externally financed</TdIndent>
                <Td>-</Td>
                <Td>-</Td>
                <Td>-</Td>
                <Td>-</Td>
                <Td>5</Td>
              </Tr>
              <Tr>
                <TdIndent>Externally financed¹</TdIndent>
                <Td>210</Td>
                <Td>141</Td>
                <Td>230</Td>
                <Td>195</Td>
                <Td>250</Td>
              </Tr>
              <Tr>
                <TdBold>Gross administrative budget (excl. carryforward)</TdBold>
                <TdBold>1,460</TdBold>
                <TdBold>1,346</TdBold>
                <TdBold>1,562</TdBold>
                <TdBold>1,522</TdBold>
                <TdBold>1,706</TdBold>
              </Tr>
              <Tr>
                <TdIndent>FY23 Fund-financed carryforward²</TdIndent>
                <Td>102</Td>
                <Td>-</Td>
                <Td>93</Td>
                <Td>-</Td>
                <Td>87</Td>
              </Tr>
              <Tr>
                <TdIndent>FY23 externally financed carryforward</TdIndent>
                <Td>-</Td>
                <Td>-</Td>
                <Td>5</Td>
                <Td>-</Td>
                <Td>5</Td>
              </Tr>
              <Tr>
                <TdIndent>Other Fund-financed transitional resources³</TdIndent>
                <Td>8</Td>
                <Td>-</Td>
                <Td>9</Td>
                <Td>-</Td>
                <Td>9</Td>
              </Tr>
              <Tr>
                <TdBold>Total gross available resources</TdBold>
                <TdBold>1,569</TdBold>
                <TdBold>1,346</TdBold>
                <TdBold>1,669</TdBold>
                <TdBold>1,522</TdBold>
                <TdBold>1,807</TdBold>
              </Tr>
              <Tr>
                <TdBold>Capital budget</TdBold>
                <TdBold>79</TdBold>
                <TdBold>90</TdBold>
                <TdBold>78</TdBold>
                <TdBold>96</TdBold>
                <TdBold>108</TdBold>
              </Tr>
              <Tr>
                <TdIndent>Building facilities</TdIndent>
                <Td>24</Td>
                <Td>22</Td>
                <Td>19</Td>
                <Td>38</Td>
                <Td>47</Td>
              </Tr>
              <Tr>
                <TdIndent>HQ1 renewal</TdIndent>
                <Td>-</Td>
                <Td>-1</Td>
                <Td>-</Td>
                <Td>-</Td>
                <Td>-</Td>
              </Tr>
              <Tr>
                <TdIndent>Information technology</TdIndent>
                <Td>46</Td>
                <Td>60</Td>
                <Td>44</Td>
                <Td>45</Td>
                <Td>41</Td>
              </Tr>
              <Tr>
                <TdIndent>Cloud capital equivalent</TdIndent>
                <Td>10</Td>
                <Td>9</Td>
                <Td>15</Td>
                <Td>13</Td>
                <Td>20</Td>
              </Tr>
            </Tbody>
            <Tfoot borderTop='2px solid black'>
              <Tr>
                <ChakraTh
                  padding={10}
                  fontWeight={600}
                  fontSize={{ base: 'sm', xl: 'md' }}
                  textTransform='none'
                  color='black'
                >
                  Net administrative budget in mil. of FY23 dollars
                </ChakraTh>
                <ThFooter fontWeight={600}>1,272</ThFooter>
                <ThFooter fontWeight={600}>1,236</ThFooter>
                <ThFooter fontWeight={600}>1,295</ThFooter>
                <ThFooter fontWeight={600}>1,294</ThFooter>
                <ThFooter fontWeight={600}>1,328</ThFooter>
              </Tr>
              <Tr>
                <ChakraTh
                  padding={10}
                  fontWeight={600}
                  fontSize={{ base: 'sm', xl: 'md' }}
                  textTransform='none'
                  color='black'
                >
                  Overseas Annual Meetings budget in mil. of FY23 dollars
                </ChakraTh>
                <ThFooter>-</ThFooter>
                <ThFooter>-</ThFooter>
                <ThFooter>-</ThFooter>
                <ThFooter>-</ThFooter>
                <ThFooter>7</ThFooter>
              </Tr>
            </Tfoot>
          </Table>
        </TableContainer>
      </Flex>
      {source && (
        <RichText value={source} fontSize='xs' fontWeight={300} mt={10} lineHeight={1.3} />
      )}
    </Container>
  );
};

export default BudgetTable;
